import React from 'react';
import Carousel from 'react-multi-carousel';
import { Link } from 'react-router-dom';
import 'react-multi-carousel/lib/styles.css';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { useCurrency } from '../../context/CurrencyContext';

const Products = ({ title, products }) => {
  const { formatBase } = useCurrency();

  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 1536 }, items: 1 },
    desktop:           { breakpoint: { max: 1536, min: 1024 }, items: 1 },
    tablet:            { breakpoint: { max: 1024, min: 464 },  items: 1 },
    mobile:            { breakpoint: { max: 464,  min: 0 },    items: 1 },
  };

  const ButtonGroup = ({ next, previous }) => (
    <div className="flex justify-between items-center mb-3">
      <h2 className="text-[15px] font-bold text-gray-800">{title}</h2>
      <div className="flex items-center gap-1.5">
        <button
          onClick={previous}
          className="w-7 h-7 flex items-center justify-center rounded-full border border-gray-200 bg-white hover:bg-gray-50 text-gray-600 transition shadow-sm"
        >
          <IoIosArrowBack size={14} />
        </button>
        <button
          onClick={next}
          className="w-7 h-7 flex items-center justify-center rounded-full border border-gray-200 bg-white hover:bg-gray-50 text-gray-600 transition shadow-sm"
        >
          <IoIosArrowForward size={14} />
        </button>
      </div>
    </div>
  );

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
      <div className="px-4 pt-4">
        <Carousel
          autoPlay={false}
          infinite={false}
          arrows={false}
          responsive={responsive}
          transitionDuration={400}
          renderButtonGroupOutside={true}
          customButtonGroup={<ButtonGroup />}
        >
          {products.map((group, i) => (
            <div key={i} className="grid grid-cols-6 md:grid-cols-3 sm:grid-cols-2 divide-x divide-gray-100">
              {group.map((p, j) => (
                <Link
                  to={`/product/details/${p.slug}`}
                  key={j}
                  className="flex flex-col items-center p-3 hover:bg-gray-50 transition group"
                >
                  <div className="w-full aspect-square overflow-hidden rounded-lg bg-gray-50">
                    <img
                      src={p.images[0]}
                      alt={p.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition duration-300"
                    />
                  </div>
                  <div className="w-full mt-2">
                    <p className="text-[11px] text-gray-600 line-clamp-2 leading-tight">{p.name}</p>
                    <p className="text-[13px] font-bold text-[#E21C1B] mt-1">{formatBase(p.price)}</p>
                  </div>
                </Link>
              ))}
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default Products;
